

const memberships = [
    {
        "id": 0,
        "name": "bronze"
    },
    {
        "id": 1,
        "name": "silver"
    },
    {
        "id": 2,
        "name": "gold"
    },
]

const addable_memberships = [
    {
        "id": 1,
        "name": "silver"
    },
    {
        "id": 2,
        "name": "gold"
    },
]


export default {
    memberships,
    addable_memberships
}